import _ from 'lodash';

const _import = require('@/libs/util.import.' + process.env.NODE_ENV);

const routes = [
  {
    path: 'records',
    name: 'bookingSpaceRecords',
    meta: {
      title: '订舱列表',
    },
    component: _import('booking/bookingSpaceRecordList.vue'),
  },
  {
    path: 'clothesDeliveryList',
    name: 'clothesDelivery',
    meta: {
      title: '成衣发货',
    },
    component: _import('booking/clothesDeliveryList.vue'),
  },
  {
    path: 'clothesDeliveryForm/:id',
    name: 'clothesDeliveryDetail',
    meta: {
      title: '成衣发货详情',
    },
    component: _import('booking/ClothesDelivery.vue'),
  },
  {
    path: 'createBookingBill',
    name: 'createBookingBill',
    meta: {
      title: '新建订舱',
    },
    component: _import('booking/createBookingBill.vue'),
  },
  {
    path: 'records/:bookingId',
    name: 'bookingSpaceDetail',
    meta: {
      title: '订舱详情!',
    },
    component: _import('booking/bookingSpaceRecordForm.vue'),
  },
  {
    path: 'declare/:bookingId',
    name: 'bookingSpaceDeclare',
    meta: {
      title: '报关',
    },
    component: _import('booking/bookingDeclare.vue'),
  },{
    path: 'billdetail/:bookingId',
    name: 'billdetail',
    meta: {
      title: '开票数据',
    },
    component: _import('booking/bookingBillDetail.vue'),
  },
];

export default _.map(routes, r => ({
  ...r,
  path: `bookingSpace/${r.path}`,
  meta: _.defaults({
    auth: true,
  }, r.meta),
}));
